import { render, staticRenderFns } from "./OurVision.vue?vue&type=template&id=4f7dcf56&"
import script from "./OurVision.vue?vue&type=script&lang=js&"
export * from "./OurVision.vue?vue&type=script&lang=js&"
import style0 from "./OurVision.vue?vue&type=style&index=0&id=4f7dcf56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
